export const environment = {
  production: true,
  URL_API: 'https://crm.poliflex.mx/crm2/Rest.svc/',
  service: 'srd',
  APIKEY: '12d4d69f8d25b75cb9664dc6bd37497d980a8a17e31e6cfed54b9f4c87ae27a1',
  version: 'PROD-07-06-2026.8'
};
 


// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-poliflex-pipeline/src/environments/environment.ts